import type { AxiosError } from "axios"

/**
 * Unified error-message extraction for network failures.
 * Prefer this over ad-hoc JSON.stringify / nested property digging.
 */
export function extractErrorMessage(e: unknown, fallback: string): string {
  if (!e || typeof e !== "object") return fallback

  const maybe = e as Record<string, unknown>

  if (typeof maybe.error === "string") return maybe.error
  if (maybe.error && typeof maybe.error === "object") {
    const nested = maybe.error as Record<string, unknown>
    if (typeof nested.error === "string") return nested.error
    if (typeof nested.message === "string") return nested.message
  }

  if (typeof maybe.message === "string" && maybe.message !== "Error") {
    return maybe.message
  }

  const axiosErr = e as AxiosError<{ error?: string; detail?: string; message?: string }>
  const data = axiosErr.response?.data
  if (data) {
    if (typeof data === "string") return data
    if (typeof data.error === "string") return data.error
    if (typeof data.detail === "string") return data.detail
    if (typeof data.message === "string") return data.message
  }

  return fallback
}
